import { sub, endOfDay } from "date-fns";

const storedPageStates = (() => {
  if (window.localStorage.pageStates) {
    const states = JSON.parse(window.localStorage.getItem("pageStates"));
    Object.entries(states).forEach(([page, state]) => {
      if (state.lastViewed) {
        states[page].lastViewed = new Date(state.lastViewed);
      }
    });
    return states;
  }
  return {};
})();

const firstPage = "1";
const firstPageReplay = "daily";
const tocPages = ["3", "4", "9", "23", "37", "40"];
// eslint-disable-next-line prettier/prettier
const allPages = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46"]
// eslint-disable-next-line prettier/prettier
const allThumbnails = ["2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46"]
const webSenseVersion = "V1623347461";
// ensure initial page states
allPages.forEach((p) => {
  storedPageStates[p] ||= {};
});

const initialState = {
  version: webSenseVersion,
  currentPage: firstPage,
  pendingPage: null,
  previousPage: null,
  loadedPages: allPages.reduce(
    (acc, p) => {
      acc[p] ||= "";
      return acc;
    },
    { [firstPage]: firstPage }
  ),
  linkedPages: {},
  thumbnails: allThumbnails,
  pageStates: { ...storedPageStates },
  openTOC: false,
  location: "web_sense",
  openThumbnailDrawer: false,
};

const resolveRelativePage = (page, relativeToPage, backPage) => {
  const relativeToPageIndex = allPages.indexOf(relativeToPage);
  if (page === "next" && relativeToPageIndex < allPages.length)
    return allPages[relativeToPageIndex + 1];
  if (page === "previous" && relativeToPageIndex > 0)
    return allPages[relativeToPageIndex - 1];
  if (page === "back" && backPage) {
    console.log(`translating back to ${backPage}`);
    return backPage;
  }
  return page;
};

// eslint-disable-next-line spaced-comment
//TODO: need to replace "back" as a page to be loaded with the previous page in state during the setCurrentPage

const pagesToLoad = (
  currentPage,
  loadedPages,
  linkedPages,
  requestedPage = currentPage,
  previousPage = ""
) => {
  const nextPages = {
    ...loadedPages,
    [currentPage]: currentPage,
    [requestedPage]: requestedPage,
  };
  const filteredPages = linkedPages.filter(
    (e) => e !== "toc" && e !== "pause" && !e.match(/http/)
  );
  Object.keys(nextPages).forEach((key) => {
    if (key === currentPage) nextPages[key] = currentPage;
    else if (key === requestedPage) nextPages[key] = requestedPage;
    else if (filteredPages.indexOf(key) >= 0) nextPages[key] = key;
    else nextPages[key] = "";
  });
  if (linkedPages.indexOf("back" >= 0)) nextPages[previousPage] = previousPage;
  console.log(`loading pages for ${currentPage}`, nextPages, filteredPages);
  return nextPages;
};

const setCurrentPage = (page, state) => {
  const loadedPages = pagesToLoad(
    page,
    state.loadedPages,
    state.linkedPages[page] || [],
    page,
    state.currentPage
  );
  return {
    currentPage: page,
    loadedPages,
  };
};

const persistPageStates = (newPageStates) => {
  const persistingStates = {};
  Object.entries(newPageStates).forEach(([page, pageState]) => {
    const { played, playedVideo, lastViewed } = pageState;
    persistingStates[page] = { played, playedVideo, lastViewed };
  });
  window.localStorage.setItem("pageStates", JSON.stringify(persistingStates));
};

const shouldReplay = (frequency, lastViewed) => {
  if (lastViewed) {
    switch (frequency) {
      case "daily":
        // console.log(
        //   `comparing ${lastViewed} to ${sub(endOfDay(new Date()), { days: 1 })}`
        // );
        return lastViewed < sub(endOfDay(new Date()), { days: 1 });
      case "weekly":
        console.log(
          `comparing ${sub(endOfDay(new Date()), {
            weeks: 1,
          })} to ${lastViewed}`
        );
        return lastViewed < sub(endOfDay(new Date()), { weeks: 1 });
      case "always":
      default:
        return true;
    }
  }
  return true;
};

export default (state = initialState, action) => {
  let currentPageStates;
  switch (action.type) {
    case "CHANGE_PAGE":
      // eslint-disable-next-line no-case-declarations
      const requestedPage = resolveRelativePage(
        action.payload.page,
        state.currentPage,
        state.previousPage
      );
      // eslint-disable-next-line no-case-declarations
      const newPreviousPage = [
        "next",
        "previous",
        "back",
        "toc",
        "pause",
      ].includes(action.payload.page)
        ? state.previousPage
        : state.currentPage;
      console.log(
        `Page ${requestedPage} requested`,
        state.pageStates[requestedPage],
        currentPageStates
      );
      switch (requestedPage) {
        case "toc":
          return {
            ...state,
            loadedPages: pagesToLoad(
              state.currentPage,
              state.loadedPages,
              tocPages
            ),
            openTOC: true,
          };
        case "pause":
          return {
            ...state,
            location: "https://pause.us",
          };
        default:
          // eslint-disable-next-line no-case-declarations
          const { loaded } = state.pageStates[requestedPage];
          // eslint-disable-next-line no-case-declarations
          let { lastViewed } = state.pageStates[requestedPage];

          if (loaded) {
            console.log(`rendering page ${requestedPage}`);
            currentPageStates = {
              pendingPage: null,
              ...setCurrentPage(requestedPage, state),
            };
            lastViewed = new Date();
          } else {
            console.log(`pending page ${requestedPage}`);
            currentPageStates = {
              pendingPage: requestedPage,
              loadedPages: pagesToLoad(
                state.currentPage,
                state.loadedPages,
                state.linkedPages[requestedPage] || [],
                requestedPage,
                state.currentPage
              ),
            };
          }
          // eslint-disable-next-line no-case-declarations
          const nextPageStates = { ...state.pageStates };
          nextPageStates[requestedPage].unloading = false;
          nextPageStates[requestedPage].lastViewed = lastViewed;

          Object.keys(nextPageStates).forEach((page) => {
            if (currentPageStates.loadedPages[page] === "")
              nextPageStates[page].loaded = false;
          });

          persistPageStates(nextPageStates);
          return {
            ...state,
            ...currentPageStates,
            previousPage: newPreviousPage,
            pageStates: nextPageStates,
          };
      }
    case "PAGE_LOADED": {
      const { loadedPage, hasVideo } = action.payload;
      const nextPageStates = {
        ...state.pageStates,
        [loadedPage]: {
          ...state.pageStates[loadedPage],
          hasVideo,
        },
      };
      if (loadedPage === firstPage && firstPageReplay)
        nextPageStates[firstPage].played = !shouldReplay(
          firstPageReplay,
          state.pageStates[firstPage].lastViewed
        );
      Object.entries(action.payload.linkedPages).forEach(([page, params]) => {
        const { param, modifier } = params;
        const resolvedPage = state.pageStates[page]
          ? page
          : resolveRelativePage(page, loadedPage);
        if (
          param === "replay" &&
          shouldReplay(modifier, state.pageStates[resolvedPage].lastViewed)
        ) {
          nextPageStates[resolvedPage].played = false;
          console.log(`clearing replay on page ${resolvedPage}`);
        }
      });
      const linkedPages = Object.keys(action.payload.linkedPages).map((page) =>
        resolveRelativePage(page, loadedPage)
      );
      // console.log(
      //   `resolved linked pages for ${loadedPage}`,
      //   linkedPages,
      //   action.payload.linkedPages
      // );
      const nextLoadedPages =
        state.currentPage === loadedPage
          ? pagesToLoad(state.currentPage, state.loadedPages, linkedPages)
          : { ...state.loadedPages };
      const currentLinkedPages = state.linkedPages[state.currentPage];
      if (currentLinkedPages)
        Object.entries(nextLoadedPages).forEach(([page, src]) => {
          const nextPageState = nextPageStates[page];
          if (nextPageState)
            if (page === state.currentPage) nextPageState.unloading = false;
            // just a safety here
            else if (currentLinkedPages.includes(src)) {
              if (nextPageState.unloading) {
                // console.log(
                //   `marking page ${page} as not unloading`,
                //   currentLinkedPages
                // );
                nextPageState.unloading = false;
              }
            } else if (nextPageState.loaded && !nextPageState.unloading) {
              // console.log(
              //   `marking page ${page} as unloading`,
              //   currentLinkedPages
              // );
              nextPageState.unloading = true;
            }
        });

      console.log(`Page ${loadedPage} loading`, linkedPages, nextPageStates);

      return {
        ...state,
        linkedPages: {
          ...state.linkedPages,
          [action.payload.loadedPage]: linkedPages,
        },
        loadedPages: nextLoadedPages,
        pageStates: nextPageStates,
      };
    }
    case "PAGE_UNLOADED": {
      return {
        ...state,
        pageStates: {
          ...state.pageStates,
          [action.payload.page]: {
            ...state.pageStates[action.payload.page],
            loaded: false,
          },
        },
      };
    }
    case "PAGE_STATE": {
      const { page } = action.payload;
      let {
        loading,
        loaded,
        unloading,
        playing,
        played,
        ended,
        hasVideo,
        createdVideo,
        playedVideo,
        videoReset,
        lastViewed,
      } = state.pageStates[page] || {};
      console.log(`Page ${page} entering state`, action.payload.state);
      switch (action.payload.state) {
        case "Stopped":
        case "DownloadingScipt": // keynote code type
        case "Starting":
        case "WaitingToJump":
        case "ReadyToJump":
          unloading = false;
          loading = true;
          loaded = false;
          playing = false;
          ended = false;
          createdVideo = false;
          break;
        case "SettingUpScene":
          loading = true;
          playing = true;
          break;
        case "IdleAtInitialState":
          loaded = true;
          loading = false;
          playing = false;
          if (page === state.currentPage) lastViewed = new Date();
          break;
        case "VideoPlayerReady":
          hasVideo = true;
          createdVideo = true;
          break;
        case "VideoReloaded":
          videoReset = true;
        // eslint-disable-next-line no-fallthrough
        case "VideoPlaying":
          hasVideo = true;
          videoReset = false;
          playedVideo = false;
          break;
        case "Playing":
          loaded = true;
          loading = false;
          playing = true;
          break;
        case "VideoEnded":
          playedVideo = true;
          videoReset = false;
          played = false;
          playing = false;
          break;
        case "IdleAtFinalState":
          playing = false;
          played = true;
          break;
        case "PositionedAtEnd":
          ended = true;
          break;
        default:
          break;
      }
      if (page === state.pendingPage && loaded && !unloading) {
        currentPageStates = {
          pendingPage: null,
          openTOC: false,
          ...setCurrentPage(action.payload.page, state),
        };
        console.log(`releasing page ${page}`, currentPageStates);
        lastViewed = new Date();
      } else currentPageStates = {};

      const newPageStates = {
        ...state.pageStates,
        [action.payload.page]: {
          loading,
          loaded,
          unloading,
          playing,
          played,
          ended,
          hasVideo,
          createdVideo,
          playedVideo,
          videoReset,
          lastViewed,
        },
      };
      persistPageStates(newPageStates);
      return {
        ...state,
        pageStates: newPageStates,
        ...currentPageStates,
      };
    }
    case "TOGGLE_THUMBNAIL_DRAWER":
      return {
        ...state,
        openThumbnailDrawer: state.currentPage !== firstPage && action.payload,
      };
    case "CLOSE_TOC":
      // console.log("closing navigation", state.pendingPage);
      return {
        ...state,
        openTOC: state.pendingPage && true,
      };
    default:
      return state;
  }
};
